import axios from "axios";
import { useState, useEffect } from "react";
import { statusIsGood } from "../../../helpers/http";
import { Tooltip } from "@mui/material";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';



export default function AdvisorReview({ review, currentYear, sarID, degreeType }) {
    const [advisorReview, setAdvisorReview] = useState({...review});
    const [validating, setValidating] = useState(false);
    const [errors, setErrors] = useState({});
    
    function handleAdvisorReview(event) {
        //if(!isLoaded) return;
        const {name, value} = event.target;
        let v =
            value === null ? "" : 
            Array.isArray(value) || isNaN(value) || value === "" ? value :
            parseInt(value);
        let [, field] = name.split(".");
        setAdvisorReview({...advisorReview, [field]: v});
    }

    const validateReview = () => {
        let newErrors = {};
        //Student Progress Value
        if(advisorReview.progressValue === "" || advisorReview.progressValue === null || advisorReview.progressValue === undefined)
            newErrors.progressValue = `Must give a rating`;
        //Student Progress Text
        if(advisorReview.descriptiveEval === "" || advisorReview.descriptiveEval.trim() === '<p><br></p>')
            newErrors.descriptiveEval = `Cannot be blank`;
        else if(advisorReview.descriptiveEval.length > 2000)
            newErrors.descriptiveEval = "Answer must be 2000 characters or less"
        //Fall Funding
        newErrors.fallFunding = {}
        advisorReview.fallFunding.forEach((funding, index) => {
            newErrors.fallFunding[index] = {}
            if(funding.fundType === "")
                newErrors.fallFunding[index] = "Must select a fund type";
            else if(typeof funding.details !== "string") {
                alert("Contact Ben Stein (bbradner@vt.edu) with this error");
                newErrors.fallFunding[index] = "Contact Ben Stein (bbradner@vt.edu) with this error";
            } else if(funding.details === "" || funding.details.trim() === '<p><br></p>')
                newErrors.fallFunding[index] = "Must provide details";
            else if(funding.details.length > 2000)
                newErrors.fallFunding[index] = "Answer must be 2000 characters or less"
            else
                delete newErrors.fallFunding[index];
        });
        if(Object.keys(newErrors.fallFunding).length < 1) delete newErrors.fallFunding;
        if(advisorReview.fallFunding.length < 1 && degreeType === "PhD")
            newErrors.fallFundingOverall = "Must have at least one funding entry";
        //Spring Funding
        newErrors.springFunding = {}
        advisorReview.springFunding.forEach((funding, index) => {
            newErrors.springFunding[index] = {}
            if(funding.fundType === "")
                newErrors.springFunding[index] = "Must select a fund type";
            else if(typeof funding.details !== "string") {
                alert("Contact Ben Stein (bbradner@vt.edu) with this error");
                newErrors.springFunding[index] = "Contact Ben Stein (bbradner@vt.edu) with this error";
            } else if(funding.details === "" || funding.details.trim() === '<p><br></p>')
                newErrors.springFunding[index] = "Must provide details";
            else if(funding.details.length > 2000)
                newErrors.springFunding[index] = "Answer must be 2000 characters or less"
            else
                delete newErrors.springFunding[index];
        });
        if(Object.keys(newErrors.springFunding).length < 1) delete newErrors.springFunding;
        if(advisorReview.springFunding.length < 1 && degreeType === "PhD")
            newErrors.springFundingOverall = "Must have at least one funding entry";
        //Funding Details
        if(typeof advisorReview.fundingDetails !== "string") {
            alert("Contact Ben Stein (bbradner@vt.edu) with this error")
            newErrors.fundingDetails = `Contact Ben Stein (bbradner@vt.edu) with this error`;
        } else if((advisorReview.fundingDetails === "" || advisorReview.fundingDetails.trim() === '<p><br></p>') && degreeType === "PhD")
            newErrors.fundingDetails = `Cannot be blank`;
        else if(advisorReview.fundingDetails.length > 2000)
            newErrors.fundingDetails = "Answer must be 2000 characters or less"
        //IDP Education Goals
        if(advisorReview.idp_education === "" || advisorReview.idp_education.trim() === '<p><br></p>')
            newErrors.idp_education = `Cannot be blank`;
        else if(advisorReview.idp_education.length > 2000)
            newErrors.idp_education = "Answer must be 2000 characters or less"
        //IDP Career Exploration
        if(advisorReview.idp_career === "" || advisorReview.idp_career.trim() === '<p><br></p>')
            newErrors.idp_career = `Cannot be blank`;
        else if(advisorReview.idp_career.length > 2000)
            newErrors.idp_career = "Answer must be 2000 characters or less"
        //IDP Professional Development
        if(advisorReview.idp_professional === "" || advisorReview.idp_professional.trim() === '<p><br></p>')
            newErrors.idp_professional = `Cannot be blank`;
        else if(advisorReview.idp_professional.length > 2000)
            newErrors.idp_professional = "Answer must be 2000 characters or less"
        setErrors(newErrors);
        return newErrors;
    }

    const checkLengths = () => {
        let newErrors = {};
        if(advisorReview.descriptiveEval.length > 2000)
            newErrors.descriptiveEval = "Answer must be 2000 characters or less"
        //Fall Funding
        newErrors.fallFunding = {}
        advisorReview.fallFunding.forEach((funding, index) => {
            newErrors.fallFunding[index] = {}
            if(funding.details === null)
                newErrors.fallFunding[index].details = "Contact Ben Stein (bbradner@vt.edu)";
            else if(funding.details.length > 2000)
                newErrors.fallFunding[index].details = "Answer must be 2000 characters or less"
            else
                delete newErrors.fallFunding[index];
        });
        if(Object.keys(newErrors.fallFunding).length < 1) delete newErrors.fallFunding;
        //Spring Funding
        newErrors.springFunding = {}
        advisorReview.springFunding.forEach((funding, index) => {
            newErrors.springFunding[index] = {}
            if(funding.details === null)
                newErrors.fallFunding[index].details = "Contact Ben Stein (bbradner@vt.edu)";
            else if(funding.details.length > 2000)
                newErrors.springFunding[index].details = "Answer must be 2000 characters or less"
            else
                delete newErrors.springFunding[index];
        });
        if(Object.keys(newErrors.springFunding).length < 1) delete newErrors.springFunding;
        //Funding Details
        if(advisorReview.fundingDetails === null)
            newErrors.fundingDetails = "Contact Ben Stein (bbradner@vt.edu)";
        else if(advisorReview.fundingDetails.length > 2000)
            newErrors.fundingDetails = "Answer must be 2000 characters or less"
        //IDP Education Goals
        if(advisorReview.idp_education.length > 2000)
            newErrors.idp_education = "Answer must be 2000 characters or less"
        //IDP Career Exploration
        if(advisorReview.idp_career.length > 2000)
            newErrors.idp_career = "Answer must be 2000 characters or less"
        //IDP Professional Development
        if(advisorReview.idp_professional.length > 2000)
            newErrors.idp_professional = "Answer must be 2000 characters or less"
        setErrors(newErrors);
        return newErrors;
    }

    const handleAdvisorReviewFallFunding = (event) => {
        const {name, value} = event.target;
        let v =
            value === null ? "" :
            isNaN(value) || value === "" ? value :
            parseInt(value);
        let [,field,index,field2] = name.split(".");
        index = parseInt(index);
        handleAdvisorReview({target: {
            name: `advisorReview.${field}`,
            value: advisorReview.fallFunding.map((fund, i) => {
                if(index === i) return {...fund, [field2]: v}
                else return fund;
            })
        }});
    }

    const addFallFunding = () => {
        handleAdvisorReview({target: {
            name: `advisorReview.fallFunding`,
            value: [...advisorReview.fallFunding, {fundType: "", details: ""}]
        }});
    }

    const dropFallFunding = (index) => {
        if(advisorReview.fallFunding.length < 2)
            handleAdvisorReview({target: {
                name: `advisorReview.fallFunding`,
                value: []
            }});
        else
            handleAdvisorReview({target: {
                name: `advisorReview.fallFunding`,
                value: advisorReview.fallFunding.filter((f,i) => i !== index)
            }});
    }

    const handleAdvisorReviewSpringFunding = (event) => {
        const {name, value} = event.target;
        let v =
            value === null ? "" :
            isNaN(value) || value === "" ? value :
            parseInt(value);
        let [,field,index,field2] = name.split(".");
        index = parseInt(index);
        handleAdvisorReview({target: {
            name: `advisorReview.${field}`,
            value: advisorReview.springFunding.map((fund, i) => {
                if(index === i) return {...fund, [field2]: v}
                else return fund;
            })
        }});
    }

    const addSpringFunding = () => {
        handleAdvisorReview({target: {
            name: `advisorReview.springFunding`,
            value: [...advisorReview.springFunding, {fundType: "", details: ""}]
        }});
    }

    const dropSpringFunding = (index) => {
        if(advisorReview.springFunding.length < 2)
            handleAdvisorReview({target: {
                name: `advisorReview.springFunding`,
                value: []
            }});
        else
            handleAdvisorReview({target: {
                name: `advisorReview.springFunding`,
                value: advisorReview.springFunding.filter((f,i) => i !== index)
            }});
    }

    const onSave = (isSubmit = false) => {
        //Validate before saving or submitting
        if(isSubmit) {
            setValidating(true);
            let validationErrors = validateReview();
            if(Object.keys(validationErrors).length > 0) {
                alert("Please fix errors before submitting");
                return;
            }
            //Double check they actually want to submit
            if(!window.confirm("Once shared you will not be able to make further changes, are you sure you would like to share your review with the student?"))
                return;
        } else {
            let lengthErrors = checkLengths();
            if(Object.keys(lengthErrors).length > 0) {
                alert("Please fix errors before saving");
                return;
            }
        }
        // If passed validation, cleanup
        let cleanedReview = {...advisorReview};
        // loop through cleanedReview and remove any "empty" values ('<p><br></p>')
        Object.keys(cleanedReview).forEach((key) => {
            if(typeof cleanedReview[key] === "string" && (cleanedReview[key].trim() === "" || cleanedReview[key].trim() === '<p><br></p>')) {
                cleanedReview[key] = "";
            }
        });
        // triple check all the funding details are strings
        cleanedReview.fallFunding = cleanedReview.fallFunding.map((fund) => {return {...fund, details: typeof fund.details !== "string" ? "" : fund.details}});
        cleanedReview.springFunding = cleanedReview.springFunding.map((fund) => {return {...fund, details: typeof fund.details !== "string" ? "" : fund.details}});
        if(typeof cleanedReview.fundingDetails !== "string") cleanedReview.fundingDetails = ""; 
        // Now save the cleaned review
        axios.post(
            `/api/sar_evals/${sarID}/advisor`,
            {...cleanedReview, reviewStatus: isSubmit ? 2 : 1}
        ).then((response) => {
            if(statusIsGood(response.status)) {
                alert(isSubmit ? "Review shared successfully" : "Review saved successfully");
                if(isSubmit) window.location.reload();
            } else {
                console.error(response.errors);
                alert("Failed to save review");
            }
        }).catch((error) => {
            if(Object.hasOwn(error.response, 'data')) {
                console.error(error.response);
                if(error.response.status === 401) {
                    alert("An error has occured with your connection and you have been logged out. "+
                        "To keep your unsaved work, please open the site in a new tab/window, log in "+
                        "(depending on how you reopen the site you may need to refresh the new tab/window to be prompted)"+
                        ", and then try resubmitting. Contact an admin if this persists.");
                } else {
                    alert(error.response.data.message)
                }
            } else {
                alert("Error saving Review, \nContact an admin if this persists.");
                console.error(error.response);
            }
        });
    }

    useEffect(() => {
        //if(!isLoaded) return;
        if(validating)
            validateReview();
         else
            checkLengths();
    }, [advisorReview, validating]);

    return (
    <fieldset>
        {advisorReview.reviewStatus === 2 &&
            <legend>Review By {advisorReview.first} {advisorReview.last} ({advisorReview.advisorPID})</legend>
        }
        {advisorReview?.progressValue !== undefined ? 
        <ol>
            <li>
                <p>How would you define the student's progress?{advisorReview.reviewStatus !== 2 && <Tooltip title="Required"><strong>*</strong></Tooltip>}</p>
                <div className="ea-options-div" style={{display:"flex", flexWrap:"wrap"}}>
                    <div className="ea-radios">
                        <input
                            type="radio"
                            id={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.progressValue-Very_Good_Progress`}
                            name={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.progressValue`}
                            value={1}
                            checked={advisorReview.progressValue === 1}
                            onChange={(e) => {if(advisorReview.reviewStatus === 2){} else handleAdvisorReview(e)}}
                        />
                        <label
                            className="form-radio-options"
                            htmlFor={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.progressValue-Very_Good_Progress`}
                        >Very Good Progress</label>
                    </div>
                    <div className="ea-radios">
                        <input
                            type="radio"
                            id={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.progressValue-Satisfactory`}
                            name={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.progressValue`}
                            value={2}
                            checked={advisorReview.progressValue === 2}
                            onChange={(e) => {if(advisorReview.reviewStatus === 2){} else handleAdvisorReview(e)}}
                        />
                        <label
                            className="form-radio-options"
                            htmlFor={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.progressValue-Satisfactory`}
                        >Satisfactory</label>
                    </div>
                    <div className="ea-radios">
                        <input
                            type="radio"
                            id={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.progressValue-Unsatisfactory`}
                            name={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.progressValue`}
                            value={3}
                            checked={advisorReview.progressValue === 3}
                            onChange={(e) => {if(advisorReview.reviewStatus === 2){} else handleAdvisorReview(e)}}
                        />
                        <label
                            className="form-radio-options"
                            htmlFor={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.progressValue-Unsatisfactory`}
                        >Unsatisfactory</label>
                    </div>
                    <div className="ea-radios">
                        <input
                            type="radio"
                            id={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.progressValue-Lack_of_Minimal_Progress`}
                            name={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.progressValue`}
                            value={4}
                            checked={advisorReview.progressValue === 4}
                            onChange={(e) => {if(advisorReview.reviewStatus === 2){} else handleAdvisorReview(e)}}
                        />
                        <label
                            className="form-radio-options"
                            htmlFor={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.progressValue-Lack_of_Minimal_Progress`}
                        >Lack of Minimal Progress</label>
                    </div>
                </div>
                <span className="feedback">{errors.progressValue}</span>
            </li>
            <li>
                <p>Please describe the student's progress{advisorReview.reviewStatus !== 2 && <Tooltip title="Required"><strong>*</strong></Tooltip>}</p>
                {/*advisorReview?.descriptiveEval !== undefined && (*/}
                    <ReactQuill
                        theme="snow"
                        defaultValue={advisorReview.descriptiveEval}
                        onChange={(value) => {
                            if(advisorReview.reviewStatus === 2) {}
                            else
                                handleAdvisorReview({target:{
                                    name: `${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.descriptiveEval`,
                                    type: "text",
                                    value,
                                    checked: false,
                            }})
                        }}
                    modules={{toolbar: advisorReview.reviewStatus === 2 ? false : [
                        ['bold', 'italic', 'underline'], 
                        [{ list: 'ordered' }, { list: 'bullet' }], 
                        ['link'], 
                    ],}}
                    readOnly={advisorReview.reviewStatus === 2}
                    placeholder={advisorReview.reviewStatus === 2 ?
                        "No descriptive evaluation provided." :
                        "Use this space to provide describe the student's progress"
                    }
                />
                {advisorReview.reviewStatus !== 2 && 
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                    <span className="feedback">{errors.descriptiveEval}</span>
                    <Tooltip title="Styling takes up extra characters">
                        <span style={{
                            color: advisorReview.descriptiveEval?.length > 2000 && "red",
                            fontWeight: advisorReview.descriptiveEval?.length >= 1900 && "bold"
                        }}>{advisorReview.descriptiveEval?.length}/2000*</span>
                    </Tooltip>
                </div>}
            </li>
            <li>
                <p style={{marginBottom: 0}}>
                    Funding Plans - Please choose one of the following options and describe your plan for funding this student in the coming year. It is important that you provide as much detail as possible in your funding plans so that the department can properly plan for and handle funding for the coming year.
                    {advisorReview.reviewStatus !== 2 && degreeType === "PhD" && (
                        <Tooltip title="Required">
                            <strong>*</strong>
                        </Tooltip>
                    )}
                </p>
                <ul style={{marginTop: 0}}>
                    <li>If you are sponsoring the student as a GRA, you <strong>must supply the fund number</strong> in the box provided below. </li>
                    <li>If the student is being funded via "1/2 GTA" or "1/2 GRA" please be sure to describe where the other parts of their funding will come from. </li>
                    <li>If the student is receiving external funding (government or company) you must specify whether it covers just tuition or includes stipend. </li>
                    <li>If you're not the primary advisor or not the one providing funding for student, please select “Other” and explain as such in the box provided below. </li>
                    <li>If you're unsure of or are still working on how to fund the student, please select "Other" and explain as such in the box provided below.</li>
                </ul>
                <table className="table fundingTable">
                    <thead>
                        <tr>
                            <th className="termColumn">Term</th>
                            <th className="typeColumn">Type</th>
                            <th>Details</th>
                            {advisorReview.reviewStatus !== 2 &&
                                <th className="actionColumn">Actions</th>
                            }
                        </tr>
                    </thead>
                    {advisorReview?.fallFunding?.length > 0 ?
                        <tbody>
                            {advisorReview.fallFunding.map((fund, index) =>
                                <tr key={`Fall ${index}`}>
                                    {index === 0 &&
                                        <td
                                            rowSpan={advisorReview.fallFunding.length + 1}
                                            className="fundingTerm"
                                        >
                                            Fall {currentYear}
                                        </td>
                                    }
                                    <td className="fundingLeft">
                                        {advisorReview.reviewStatus === 2 ?
                                            <input
                                                type="text"
                                                className="form-control"
                                                name={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.fallFunding.${index}.fundType`}
                                                style={{width:'113px', textAlign:'center'}}
                                                value={fund.fundType}
                                                disabled
                                            /> :
                                            <select
                                                className="form-select"
                                                name={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.fallFunding.${index}.fundType`}
                                                value={fund.fundType}
                                                onChange={handleAdvisorReviewFallFunding}
                                            >
                                                <option></option>
                                                <option>GRA</option>
                                                <option>GTA</option>
                                                <option>GA</option>
                                                <option>1/2 GRA</option>
                                                <option>1/2 GTA</option>
                                                <option>Fellowship</option>
                                                <option>Self-Funded</option>
                                                <option>Government</option>
                                                <option>Company</option>
                                                <option>Not Enrolled</option>
                                                <option>Other</option>
                                            </select>
                                        }
                                        <span className="feedback">{errors.fallFunding?.[index]}</span>
                                    </td>
                                    <td>
                                        <textarea
                                            name={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.fallFunding.${index}.details`}
                                            className="form-control"
                                            value={fund.details}
                                            onChange={handleAdvisorReviewFallFunding}
                                            rows={3}
                                            disabled={advisorReview.reviewStatus === 2}
                                        />
                                    </td>
                                    {advisorReview.reviewStatus !== 2 &&
                                    <td>
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => dropFallFunding(index)}
                                        >Delete</button>
                                        {advisorReview.reviewStatus !== 2 && 
                                        <div>
                                            <Tooltip title="Styling takes up extra characters">
                                                <span style={{color: fund.details?.length > 1000 && "red", fontWeight: fund.details?.length >= 900 && "bold"}}>{fund.details?.length}/1000*</span>
                                            </Tooltip>
                                        </div>}
                                    </td>}
                                </tr>
                    
                            )}
                            {advisorReview.reviewStatus !== 2 &&
                            <tr>
                                {advisorReview.reviewStatus !== 2 ?
                                <td className="fundingLeft" colSpan={3}>
                                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                                        <span className="feedback">{errors.fallFundingOverall}</span>
                                        <button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={addFallFunding}
                                        >Add Funding</button>
                                    </div>
                                </td>
                                : <td className="fundingLeft" colSpan={2}></td>}
                            </tr>}
                        </tbody>:
                        <tbody>
                            <tr>
                                <td className="fundingTerm">Fall {currentYear}</td>
                                {advisorReview.reviewStatus !== 2 ?
                                <td className="fundingLeft" colSpan={3}>
                                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                                        <span className="feedback">{errors.fallFundingOverall}</span>
                                        <button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={addFallFunding}
                                        >Add Funding</button>
                                    </div>
                                </td>:
                                <td className="fundingLeft" colSpan={2}>No Funding Details Provided</td>}
                            </tr>
                        </tbody>
                    }
                    {advisorReview?.springFunding?.length > 0 ?
                        <tbody>
                            {advisorReview.springFunding.map((fund, index) =>
                                <tr key={`Spring ${index}`}>
                                    {index === 0 &&
                                        <td
                                            rowSpan={advisorReview.springFunding.length + 1}
                                            className="fundingTerm"
                                        >
                                            Spring {currentYear+1}
                                        </td>
                                    }
                                    <td className="fundingLeft">
                                        {advisorReview.reviewStatus === 2 ?
                                            <input
                                                type="text"
                                                className="form-control"
                                                name={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.springFunding.${index}.fundType`}
                                                style={{width:'113px', textAlign:'center'}}
                                                value={fund.fundType}
                                                disabled
                                            /> :
                                            <select
                                                className="form-select"
                                                name={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.springFunding.${index}.fundType`}
                                                value={fund.fundType}
                                                onChange={handleAdvisorReviewSpringFunding}
                                            >
                                                <option></option>
                                                <option>GRA</option>
                                                <option>GTA</option>
                                                <option>GA</option>
                                                <option>1/2 GRA</option>
                                                <option>1/2 GTA</option>
                                                <option>Fellowship</option>
                                                <option>Self-Funded</option>
                                                <option>Government</option>
                                                <option>Company</option>
                                                <option>Not Enrolled</option>
                                                <option>Other</option>
                                            </select>
                                    }
                                        <span className="feedback">{errors.springFunding?.[index]}</span>
                                    </td>
                                    <td>
                                        <textarea
                                            name={`${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.springFunding.${index}.details`}
                                            className="form-control"
                                            value={fund.details}
                                            onChange={handleAdvisorReviewSpringFunding}
                                            rows={3}
                                            disabled={advisorReview.reviewStatus === 2}
                                        />
                                    </td>
                                    {advisorReview.reviewStatus !== 2 &&
                                    <td>
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => dropSpringFunding(index)}
                                        >Delete</button>
                                        {advisorReview.reviewStatus !== 2 && 
                                        <div>
                                            <Tooltip title="Styling takes up extra characters">
                                                <span style={{color: fund.details?.length > 1000 && "red", fontWeight: fund.details?.length >= 900 && "bold"}}>{fund.details?.length}/1000*</span>
                                            </Tooltip>
                                        </div>}
                                    </td>}
                                </tr>
                    
                            )}
                            {advisorReview.reviewStatus !== 2 &&
                            <tr>
                                <td className="fundingLeft" colSpan={3}>
                                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                                        <span className="feedback">{errors.springFundingOverall}</span>
                                        <button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={addSpringFunding}
                                        >Add Funding</button>
                                    </div>
                                </td>
                            </tr>}
                        </tbody>:
                        <tbody>
                            <tr>
                                <td className="fundingTerm">Spring {currentYear + 1}</td>
                                {advisorReview.reviewStatus !== 2 ?
                                <td colSpan={3} className="fundingLeft">
                                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                                        <span className="feedback">{errors.springFundingOverall}</span>
                                        <button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={addSpringFunding}
                                        >Add Funding</button>
                                    </div>
                                </td>
                                : <td className="fundingLeft" colSpan={2}>No Funding Details Provided</td>}
                            </tr>
                        </tbody>
                    }
                </table>
                <ReactQuill
                    theme="snow"
                    defaultValue={advisorReview.fundingDetails}
                    onChange={(value) => {
                        if(advisorReview.reviewStatus === 2) {}
                        else
                            handleAdvisorReview({target:{
                                name: `${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.fundingDetails`,
                                type: "text",
                                value,
                                checked: false,
                            }})
                        }}
                    modules={{toolbar: advisorReview.reviewStatus === 2 ? false : [
                        ['bold', 'italic', 'underline'], 
                        [{ list: 'ordered' }, { list: 'bullet' }], 
                        ['link'], 
                    ],}}
                    readOnly={advisorReview.reviewStatus === 2}
                    placeholder={advisorReview.reviewStatus === 2 ?
                        "No funding details provided." :
                        "Use this space to provide any additional details about your funding plans for this student"
                    }
                />
                {advisorReview.reviewStatus !== 2 && 
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                    <span className="feedback">{errors.fundingDetails}</span>
                    <Tooltip title="Styling takes up extra characters">
                        <span style={{
                                color: advisorReview.fundingDetails?.length > 2000 && "red",
                                fontWeight: advisorReview.fundingDetails?.length >= 1900 && "bold"
                        }}>{advisorReview.fundingDetails?.length}/2000*</span>
                    </Tooltip>
                </div>}
            </li>
            <li>
                <p>Feedback on Individual Development Plan</p>
                <ol type="a">
                    <li>
                        <h3>Educational Goals{advisorReview.reviewStatus !== 2 && <Tooltip title="Required"><strong>*</strong></Tooltip>}</h3>
                        <ReactQuill
                            theme="snow"
                            defaultValue={advisorReview.idp_education}
                            onChange={(value) => {
                                if(advisorReview.reviewStatus === 2) {}
                                else
                                    handleAdvisorReview({target:{
                                    name: `${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.idp_education`,
                                    type: "text",
                                    value,
                                    checked: false,
                                }})
                            }}
                            modules={{toolbar: advisorReview.reviewStatus === 2 ? false : [
                                ['bold', 'italic', 'underline'], 
                                [{ list: 'ordered' }, { list: 'bullet' }], 
                                ['link'], 
                            ],}}
                            readOnly={advisorReview.reviewStatus === 2}
                            placeholder={advisorReview.reviewStatus === 2 ?
                                "No feedback provided." :
                                "Use this space to provide any feedback on the student's educational goals"
                            }
                        />
                        {advisorReview.reviewStatus !== 2 && 
                        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                            <span className="feedback">{errors.idp_education}</span>
                            <Tooltip title="Styling takes up extra characters">
                                <span style={{
                                    color: advisorReview.idp_education?.length > 2000 && "red",
                                    fontWeight: advisorReview.idp_education?.length >= 1900 && "bold"
                                }}>{advisorReview.idp_education?.length}/2000*</span>
                            </Tooltip>
                        </div>}
                    </li>
                    <li>
                        <h3>Career Exploration{advisorReview.reviewStatus !== 2 && <Tooltip title="Required"><strong>*</strong></Tooltip>}</h3>
                        <ReactQuill
                            theme="snow"
                            defaultValue={advisorReview.idp_career}
                            onChange={(value) => {
                                if(advisorReview.reviewStatus === 2) {}
                                else
                                    handleAdvisorReview({target:{
                                    name: `${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.idp_career`,
                                    type: "text",
                                    value,
                                    checked: false,
                                }})
                            }}
                            modules={{toolbar: advisorReview.reviewStatus === 2 ? false : [
                                ['bold', 'italic', 'underline'], 
                                [{ list: 'ordered' }, { list: 'bullet' }], 
                                ['link'], 
                            ],}}
                            readOnly={advisorReview.reviewStatus === 2}
                            placeholder={advisorReview.reviewStatus === 2 ?
                                "No feedback provided." :
                                "Use this space to provide any feedback on the student's career exploration goals"
                            }
                        />
                        {advisorReview.reviewStatus !== 2 && 
                        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                            <span className="feedback">{errors.idp_career}</span>
                            <Tooltip title="Styling takes up extra characters">
                                <span style={{
                                    color: advisorReview.idp_career?.length > 2000 && "red",
                                    fontWeight: advisorReview.idp_career?.length >= 1900 && "bold"
                                }}>{advisorReview.idp_career?.length}/2000*</span>
                            </Tooltip>
                        </div>}
                    </li>
                    <li>
                        <h3>Professional Development{advisorReview.reviewStatus !== 2 && <Tooltip title="Required"><strong>*</strong></Tooltip>}</h3>
                        <ReactQuill
                            theme="snow"
                            defaultValue={advisorReview.idp_professional}
                            onChange={(value) => {
                                if(advisorReview.reviewStatus === 2) {}
                                else
                                    handleAdvisorReview({target:{
                                    name: `${advisorReview.reviewStatus === 2 ? `${advisorReview.advisorPID}advisorReview` : "draftadvisorReview"}.idp_professional`,
                                    type: "text",
                                    value,
                                    checked: false,
                                }})
                            }}
                            modules={{toolbar: advisorReview.reviewStatus === 2 ? false : [
                                ['bold', 'italic', 'underline'], 
                                [{ list: 'ordered' }, { list: 'bullet' }], 
                                ['link'], 
                            ],}}
                            readOnly={advisorReview.reviewStatus === 2}
                            placeholder={advisorReview.reviewStatus === 2 ?
                                "No feedback provided." :
                                "Use this space to provide any feedback on the student's professional development goals"
                            }
                        />
                        {advisorReview.reviewStatus !== 2 && 
                        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                            <span className="feedback">{errors.idp_professional}</span>
                            <Tooltip title="Styling takes up extra characters">
                                <span style={{
                                    color: advisorReview.idp_professional?.length > 2000 && "red",
                                    fontWeight: advisorReview.idp_professional?.length >= 1900 && "bold"
                                }}>{advisorReview.idp_professional?.length}/2000*</span>
                            </Tooltip>
                        </div>}
                    </li>
                </ol>
            </li>
        </ol>:<></>}
        {advisorReview.reviewStatus !== 2 &&
        <div style={{display:"flex", justifyContent:"flex-end", alignItems:"baseline"}}>
            <div className="form-check">
                <input
                    id="validation-checkbox"
                    name="validation-checkbox"
                    type="checkbox"
                    className="form-check-input"
                    checked={validating}
                    onChange={(e) => setValidating(e.target.checked)}
                />
                <label
                    htmlFor="validation-checkbox"
                    className="form-check-label"
                    style={{paddingRight: "10px"}}
                >Validating?</label>
            </div>
            {/*<button
                type="button"
                className="btn btn-primary"
                onClick={() => console.log(advisorReview)}
            >Info</button>*/}
            <button
                type="button"
                className="btn btn-success"
                onClick={() => onSave(false)}
            >Save</button>
            <button
                type="button"
                className="btn btn-warning"
                onClick={() => onSave(true)}
            >Share</button>
        </div>}
    </fieldset>);
}